/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：产品(product)相关的所有接口地址定义
 */

// 产品列表
export const productList = '/product/product/list'
// 产品分类列表
export const typeList = '/product/product/type-list'
// 添加产品
export const addProduct = '/product/product/add-custom'
// 修改产品
export const editProduct = '/product/product/save-item-price'
// 删除产品
export const delProduct = '/product/product/del'
// 设置产品是否常用
export const setCommon = '/product/product/set-common'
// 设置制作项置顶
export const setTop = '/product/product/set-top'
// 定制产品类别
export const getCategoryList = '/product/custom-goods/get-category-list'



// WEBPACK FOOTER //
// ./src/api/url/product.js